import { render, staticRenderFns } from "./TopCategories.vue?vue&type=template&id=cfd17210&scoped=true"
import script from "./TopCategories.vue?vue&type=script&lang=js"
export * from "./TopCategories.vue?vue&type=script&lang=js"
import style0 from "./TopCategories.vue?vue&type=style&index=0&id=cfd17210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd17210",
  null
  
)

export default component.exports